export default __webpack_public_path__ + "static/media/game.81cd98e9.png";